<script>
export default {
  name: 'GlobalDropOverlay',
}
</script>

<template>
<div v-if="$store.state.ui.fileDrop.active" class="global-drop-overlay position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
  <div class="drop-message text-center">
    <div class="icon mb-2"><fa-icon :icon="['fas','cloud-arrow-down']" /></div>
    <div class="title">Drop file anywhere</div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.global-drop-overlay {
  z-index: 2000;
  background: rgba(0, 0, 0, 0.55);
  pointer-events: none;

  .drop-message {
    color: #fff;
    font-size: 1.5rem;
    line-height: 2rem;
    background: rgba(0, 0, 0, 0.35);
    border: 1px dashed rgba(255,255,255,0.5);
    border-radius: 12px;
    padding: 16px 24px;
  }
}
</style>


